<template>
    <div id="details">
        <v-container>
            <h1 class="page-title mouse-hover hover-invert">BlueBOT</h1>
            <div class="details-content">
                <v-row align="start">
                    <!-- Left column: existing content -->
                    <v-col cols="12" md="7">
                        <div class="detail-card">
                            <div class="detail-description">
                                <p class="mouse-hover hover-invert">
                                    Το BlueBOT είναι ένα υποβρύχιο ρομπότ που αποτρέπει την ανάπτυξη βιορρύπανσης στο κύτος των πλοίων και παρέχει βέλτιστη ενεργειακή απόδοση ανεξάρτητα από το προφίλ λειτουργίας του σκάφους.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Το BlueBOT είναι ένα υποβρύχιο ερπυστριοφόρο ρομπότ που χρησιμοποιεί ελαστομερείς ιμάντες που διατηρούνται σε επαφή με το κύτος χρησιμοποιώντας ισχυρούς μόνιμους μαγνήτες. Χάρη στο προηγμένο λογισμικό πλοήγησης, το ρομπότ μπορεί να λειτουργήσει αυτόνομα ακολουθώντας τη βέλτιστη διαδρομή, ενώ είναι επίσης δυνατή η απομακρυσμένη λειτουργία από έναν χρήστη.
                                </p>
                                <p class="mouse-hover hover-invert">
                                    Ο έξυπνος εντοπισμός της θέσης του ερπυστριοφόρου σε συνδυασμό με τους ενσωματωμένους αλγόριθμους αναγνώρισης βιορρύπανσης που βασίζονται στην τεχνητή νοημοσύνη χρησιμοποιούνται για την αυτοματοποιημένη ποσοτικοποίηση της, την δημιουργία μιας αναφοράς και του αντίστοιχου χάρτη στο κύτος, κατάλληλης για χρήση με τις αρχές, καθώς και την πλήρη καταγραφή του καθαρισμού με βίντεο.
                                </p>
                            </div>
                            <div class="detail-image-container">
                                <v-img
                                    src="@/assets/details/Digital Products_Poster_BlueBOT.jpg"
                                    contain
                                    class="detail-image"
                                    alt="BlueBOT Poster"
                                ></v-img>
                            </div>
                        </div>
                    </v-col>

                    <!-- Right column: project info -->
                    <v-col cols="12" md="5">
                        <div class="detail-card project-info-card">
                            <div class="project-info-section">
                                <h3 class="info-label mouse-hover hover-invert">ΠΕΡΙΓΡΑΦΗ ΕΡΓΟΥ</h3>
                                <p class="info-value mouse-hover hover-invert">
                                    Υποβρύχιο ρομπότ που αποτρέπει τη βιορρύπανση στο κύτος πλοίων για βέλτιστη ενεργειακή απόδοση. Ο έξυπνος εντοπισμός θέσης και οι αλγόριθμοι τεχνητής νοημοσύνης επιτρέπουν αυτόματη ποσοτικοποίηση, χαρτογράφηση και πλήρη βιντεοσκοπημένη τεκμηρίωση του καθαρισμού.
                                </p>
                            </div>

                            <div class="project-info-section">
                                <h3 class="info-label mouse-hover hover-invert">ΠΡΟΥΠΟΛΟΓΙΣΜΟΣ</h3>
                                <p class="info-value info-highlight mouse-hover hover-invert">1.516.000,00 €</p>
                            </div>

                            <div class="project-info-section">
                                <h3 class="info-label mouse-hover hover-invert">ΧΡΗΜΑΤΟΔΟΤΗΣΗ Ε.Ε.</h3>
                                <p class="info-value info-highlight mouse-hover hover-invert">744.000,00 €</p>
                            </div>

                            <div class="project-info-section">
                                <p class="info-value mouse-hover hover-invert">
                                    Το έργο υλοποιείται στο πλαίσιο της Δράσης:<br>
                                    <strong>«Ανάπτυξη Ψηφιακών Προϊόντων και Υπηρεσιών»</strong><br>
                                    και χρηματοδοτείται από:
                                </p>
                                <ul class="funding-list mouse-hover hover-invert">
                                    <li class="mouse-hover hover-invert">το Ταμείο Ανάκαμψης και Ανθεκτικότητας (RRF)</li>
                                    <li class="mouse-hover hover-invert">το Εθνικό Σχέδιο Ανάκαμψης και Ανθεκτικότητας «Ελλάδα 2.0»</li>
                                    <li class="mouse-hover hover-invert">την Ευρωπαϊκή Ένωση – NextGenerationEU</li>
                                </ul>
                            </div>

                            <div class="project-info-section">
                                <h3 class="info-label mouse-hover hover-invert">ΔΙΑΡΚΕΙΑ ΕΡΓΟΥ</h3>
                                <p class="info-value mouse-hover hover-invert">24 μήνες</p>
                            </div>

                            <div class="project-info-section">
                                <h3 class="info-label mouse-hover hover-invert">ΣΧΕΤΙΚΟΙ ΣΥΝΔΕΣΜΟΙ</h3>
                                <ul class="links-list">
                                    <li><a href="https://digitalsme.gov.gr" target="_blank" class="project-link mouse-hover hover-invert">digitalsme.gov.gr</a></li>
                                    <li><a href="https://greece20.gov.gr" target="_blank" class="project-link mouse-hover hover-invert">greece20.gov.gr</a></li>
                                </ul>
                            </div>

                            <div class="detail-image-container">
                                <v-img
                                    src="@/assets/details/bluebot scruffy 100X200.jpg"
                                    contain
                                    class="detail-image"
                                    alt="BlueBOT Scruffy"
                                ></v-img>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<style scoped>
#details {
    padding-top: var(--abh);
    background: rgba(7, 28, 52, 0.8);
    min-height: calc(var(--vh, 1vh) * 100);
}

.details-content {
    padding: 2rem 0;
}

.detail-card {
    background: rgba(32, 92, 242, 0.05);
    border: 1px solid rgba(32, 92, 242, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin: 2rem 0;
}

.detail-title {
    color: var(--v-primary-base);
    text-align: center;
    margin-bottom: 1.5rem;
}

.detail-description {
    color: #ECEAEA;
    margin-bottom: 2rem;
    line-height: 1.6;
}

.detail-description p {
    margin-bottom: 1rem;
    text-align: justify;
}

.detail-image-container {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.detail-image {
    max-width: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(32, 92, 242, 0.3);
}

.project-info-card {
    height: 100%;
}

.project-info-section {
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid rgba(32, 92, 242, 0.15);
}

.project-info-section:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.info-label {
    color: var(--v-primary-base, #205CF2);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
}

.info-value {
    color: #ECEAEA;
    line-height: 1.6;
    margin: 0;
}

.info-highlight {
    font-size: 1.25rem;
    font-weight: 600;
    color: #ECEAEA;
}

.funding-list,
.links-list {
    color: #ECEAEA;
    padding-left: 1.2rem;
    margin-top: 0.5rem;
    line-height: 1.8;
}

.project-link {
    color: var(--v-primary-base, #205CF2);
    text-decoration: none;
    transition: opacity 0.2s;
}

.project-link:hover {
    opacity: 0.75;
}

@media screen and (max-width: 960px) {
    .detail-card {
        padding: 1.5rem;
    }

    .detail-description p {
        text-align: left;
    }
}
</style>

<script>
export default {
    name: 'Details',
    mounted() {
        this.$store.state.app_bar_visible = true;
    }
}
</script>
